// extracted by mini-css-extract-plugin
export default {"add":"NSUE9KfcR396yLHf4CRa","attribute":"A3IWvXKP9jQ1tejajAOP","settings":"jfU1oHAUrTkfzrV9RhQf"};